import React, {useEffect} from 'react';
import {TextInput, Text, Button} from '@/ui-kits';
import {FormLayout} from './FormLayout';
import {useFormik} from 'formik';
import {LoginFormValidation} from '@/utils/schema';
import {Routes} from '@/navigation/Routes';
import { useNavigate, useLocation } from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {loginOtpRequest} from '@/services/redux/slices';
/*
 * these are the initial values and types for login form
 */

interface LoginFormInterface {
  email_id: string;
}

const LoginFormInitialValues: LoginFormInterface = {email_id: ''};

export const LoginForm: React.FC = () => {

  // ================================
  // hooks
  // ================================
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get form data from navigation state (when coming back from OTP)
  const navigationState = location.state as { fromOTP?: boolean; email_id?: string } | null;
  const prefilledEmail = navigationState?.fromOTP ? navigationState.email_id : '';
  
  const {
    values,
    handleChange,
    touched,
    errors,
    handleBlur,
    dirty,
    isValid,
    handleSubmit,
  } = useFormik({
    initialValues: {
      ...LoginFormInitialValues,
      email_id: prefilledEmail || LoginFormInitialValues.email_id,
    },
    validationSchema: LoginFormValidation,
    onSubmit,
    enableReinitialize: true,
  });

  // ================================
  // functions
  // ================================
  function gotoSignupScreen() {
    navigate(Routes.SIGNUP);
  }
  
  function onSubmit(formValues: LoginFormInterface) {
    dispatch(loginOtpRequest(formValues));
  }

  // ================================
  // side effects
  // ================================
  // Clear navigation state after using it to prevent it from persisting
  useEffect(() => {
    if (navigationState?.fromOTP) {
      // Replace current location to remove state from history
      window.history.replaceState({}, document.title, location.pathname);
    }
  }, [navigationState, location.pathname]);

  return (
    <FormLayout>
      <div className='flex flex-col gap-4 px-4'>
        <Text variant="title" className='inline-flex gap-2 font-FigtreeBold self-center text-ui_blue'>
          {'Log In for '}
          <p id="logo-text">
            {'Second opinion'}
          </p>
        </Text>

        <TextInput
          name="email_id"
          required
          label="Email ID"
          placeholder="Enter the registered email ID"
          value={values.email_id}
          touched={touched.email_id}
          disableAutofill={true}
          error={errors.email_id}
          onChangeText={handleChange('email_id')}
          onBlur={handleBlur('email_id')}
        />
        <Button
          onClick={() => handleSubmit()}
          title="Next"
          disabled={!isValid || (!dirty && !prefilledEmail)}
          variant="primary"
          className="w-[80%] items-center self-center px-8 py-2 mt-8 rounded-lg"
          rightIcon="arrow_circle_white_right"
        />
      </div>

      <div className='flex flex-col gap-2 items-center mt-10'>
        <Text className='font-Label text-sm text-ui_blue opacity-80 self-center' variant="subtitle">
          Don’t have an account? Create one.
        </Text>
        <Text onClick={gotoSignupScreen} className="text-ui_blue font-headingBold text-base cursor-pointer" variant="subtitle">
          Sign Up
        </Text>
      </div>
    </FormLayout>
  );
};